import { Box, Typography, Paper } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useReportContext } from '../ReportContext';
import { Outstandingdata } from '../../newReports/data';
import { useSearchParams, useParams } from 'react-router-dom';
import NewOutStandingReport from '../../../../components/Table/NewOutStandingReport';
import NewPayableReceivableAgeing from '../../../../components/Table/NewPayableReceivableAgeing';
import NewPayableReceivableAgeingTable from '../../../../components/Table/NewPayableReceivableAgeingTable';

const Outstanding = () => {
  const { updateReportData } = useReportContext();
  const [searchParams] = useSearchParams();
  const { id: reportId } = useParams();
  const previousReportIdRef = useRef(reportId);
  const [selectedReports, setSelectedReports] = useState([]);

  // Map account IDs to report types and components
  const reportTypeMap = {
    '010': {
      component: 'NewOutStandingReport',
      reportType: 'ReceivableOutStanding',
      tableName: 'Receivable',
    },
    '020': {
      component: 'NewPayableReceivableAgeing',
      reportType: 'ReceivableOutStanding',
      tableName: 'Receivable Ageing',
    },
    '030': {
      component: 'NewOutStandingReport',
      reportType: 'PayableOutStanding',
      tableName: 'Payable',
    },
    '040': {
      component: 'NewPayableReceivableAgeing',
      reportType: 'PayableOutStanding',
      tableName: 'Payable Ageing',
    },
  };

  // Update context with available Outstanding accounts for the header dropdown
  useEffect(() => {
    updateReportData({
      allAccounts: Outstandingdata,
      // loading: false,
    });
  }, []);

  // Clear data when report ID changes
  useEffect(() => {
    if (previousReportIdRef.current !== reportId && previousReportIdRef.current !== null) {
      setSelectedReports([]);
    }
    previousReportIdRef.current = reportId;
  }, [reportId]);

  // Fetch and display reports based on URL 'ids'
  useEffect(() => {
    const idsParam = searchParams.get('ids');

    // First, sync selectedReports with URL - remove any reports not in URL
    setSelectedReports((prevReports) => {
      if (!idsParam) {
        return [];
      }
      const decodedIds = decodeURIComponent(idsParam);
      const currentSelectedIds = decodedIds
        .split(',')
        .filter(Boolean)
        .map((id) => id.trim());
      return prevReports.filter((report) => currentSelectedIds.includes(String(report.accountId)));
    });

    if (!idsParam) {
      return;
    }

    const decodedIds = decodeURIComponent(idsParam);
    const currentSelectedIds = decodedIds
      .split(',')
      .filter(Boolean)
      .map((id) => id.trim());

    const newReportsToDisplay = currentSelectedIds
      .map((accountId) => {
        const matchingData = Outstandingdata.find((item) => String(item.accountsid) === String(accountId));
        if (matchingData && reportTypeMap[accountId]) {
          return {
            accountId,
            ...reportTypeMap[accountId],
          };
        }
        return null;
      })
      .filter(Boolean); // Filter out any nulls

    setSelectedReports((prevReports) => {
      const updatedReports = [...prevReports];
      newReportsToDisplay.forEach((newReport) => {
        const existingIndex = updatedReports.findIndex((r) => String(r.accountId) === String(newReport.accountId));
        if (existingIndex === -1) {
          updatedReports.push(newReport);
        }
      });
      return updatedReports;
    });
  }, [searchParams, reportId]);

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      {selectedReports.length === 0 ? (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h4" gutterBottom>
            Outstanding Reports
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Please select report types from the header to view Outstanding reports
          </Typography>
        </Paper>
      ) : (
        selectedReports.map((report) => (
          <Box key={report.accountId}>
            {report.component === 'NewOutStandingReport' ? (
              <NewOutStandingReport reportType={report.reportType} tableName={report.tableName} />
            ) : (
              // <NewPayableReceivableAgeing reportType={report.reportType} tableName={report.tableName} />
              <NewPayableReceivableAgeingTable reportType={report.reportType} tableName={report.tableName} />
            )}
          </Box>
        ))
      )}
    </Box>
  );
};

export default Outstanding;
